function chatNoirOpeningStatus(at = new Date()) {
  if (at < new Date('2026-10-16T12:00:00+02:00')) return { state: 'closed', key: 'reopening' };
  const parts = Object.fromEntries(new Intl.DateTimeFormat('en-GB', {
    timeZone: 'Europe/Paris', year: 'numeric', month: '2-digit', day: '2-digit',
    hour: '2-digit', minute: '2-digit', hourCycle: 'h23'
  }).formatToParts(at).map(p => [p.type, p.value]));
  const weekday = new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day))).getUTCDay();
  const minute = Number(parts.hour) * 60 + Number(parts.minute);
  const schedule = [
    [[630, 870]], [], [], [[720, 840]],
    [[720, 840], [1140, 1320]], [[720, 840], [1140, 1320]], [[720, 840], [1140, 1320]]
  ];
  const time = m => Math.floor(m / 60) + 'h' + (m % 60 ? String(m % 60).padStart(2, '0') : '');
  for (const [start, end] of schedule[weekday]) {
    if (minute >= start && minute < end) return { state: 'open', key: 'open', time: time(end) };
    if (minute < start) return { state: 'closed', key: 'today', time: time(start) };
  }
  for (let offset = 1; offset <= 7; offset++) {
    const next = (weekday + offset) % 7;
    if (schedule[next].length) return {
      state: 'closed', key: offset === 1 ? 'tomorrow' : 'next',
      day: String(next), time: time(schedule[next][0][0])
    };
  }
}
if (typeof module !== 'undefined' && module.exports) module.exports = chatNoirOpeningStatus;
if (typeof document !== 'undefined') {
  (() => {
    const update = () => {
      const status = chatNoirOpeningStatus();
      document.querySelectorAll('[data-chat-noir-status]').forEach(el => {
        const text = el.dataset[status.key].replace('{time}', status.time || '').replace('{day}', el.dataset['day' + status.day] || '');
        const label = el.querySelector('[data-status-label]');
        if (label.textContent !== text) label.textContent = text;
        el.dataset.state = status.state;
      });
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', update, { once: true });
    else update();
    setInterval(update, 30000);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) update(); });
    window.addEventListener('focus', update);
    document.addEventListener('shopify:section:load', update);
  })();
}
